// The Amazon buildings as every view of the overview shows them: each step present, every
// value written over Steps 2 and 3 applied, earliest committed COD first; and Step 1's
// steps as the shared blueprint has them.
import { useMemo } from "react";

import { useAmazonBlueprint } from "../../api/hooks/useAmazonBlueprint";
import { useAmazonBuildingNotes } from "../../api/hooks/useAmazonBuildingNotes";
import { useAmazonOverview } from "../../api/hooks/useAmazonOverview";
import { blueprintSteps } from "./blueprint";
import { setBankHolidays } from "./dates";
import {
  applyOverrides,
  byCommittedCod,
  NO_OVERRIDES,
  overridesByBuilding,
} from "./overrides";
import { withEveryStep } from "./schedule";

export const useShownBuildings = () => {
  const buildings = useAmazonOverview();
  const every = useMemo(() => {
    // The calendar every Business Day on the page counts against, before anything reads it.
    if (buildings.data) setBankHolidays(buildings.data.bank_holidays);
    return (buildings.data?.buildings ?? []).map(withEveryStep);
  }, [buildings.data]);
  const notes = useAmazonBuildingNotes();
  const byBuilding = useMemo(() => overridesByBuilding(notes.data ?? []), [notes.data]);
  // Re-sorted so an overridden COD moves its row and its tab.
  const shown = useMemo(
    () =>
      every
        .map((b) => applyOverrides(b, byBuilding.get(b.project_id) ?? NO_OVERRIDES))
        .sort(byCommittedCod),
    [every, byBuilding],
  );
  const platform = useMemo(() => new Map(every.map((b) => [b.project_id, b])), [every]);
  const blueprint = useAmazonBlueprint();
  const steps = useMemo(() => blueprintSteps(blueprint.data ?? []), [blueprint.data]);
  return { buildings, notes, byBuilding, shown, platform, blueprint, steps };
};
